import QueryString from 'qs';

const endpointName = 'Itineraries';
const EditItinerary = {
  /**
   * @description function to download the confirmation invoice
   * @param id {string} = the id of the itinerary to download
   * @returns a promise
   */
  downloadConfirmationInvoice: function(id, options) {
    const query = QueryString.stringify(options, { addQueryPrefix: true });
    return this.axios({
      method: 'GET',
      url: `/api/${endpointName}/${id}/download-confirmation-invoice${query}`,
      responseType: 'blob',
    });
  },
};

export default EditItinerary;
